import React, {Component, createRef, forwardRef} from 'react';
import FJDropDown from "fj-components/FJDropDown"
import FJRecordingSet from "./FJRecordingSet";

import styles from './FJVideoTapeTool.module.less';
import InlineSVG from "react-inlinesvg";
import FJRecodingCameraIcon from '../../../../icon/recordCamera.svg';
import FJCameraSettingIcon from '../../../../icon/cameraSetting.svg';
import FJLocalStore from "../../../../store/FJLocalStore";

const ForwardTrigger = forwardRef((props, ref) => {
  return (
    <div ref={ref} className={styles.set_btn + ' u-tooltip-top'} tooltip={FJLocalStore._('set')}>
      <div className={styles.set_btn_inner}>
        <InlineSVG src={FJCameraSettingIcon} element='div'/>
      </div>
    </div>
  );
});

class FJVideoTapeTool extends Component {

  constructor(props) {
    super(props);
    this.state = {
      disabledMouseEvent: true
    };
    this._videoTapeTool = createRef();
    this._takePhoto = createRef();
    this._recordingBtn = createRef();
    this._pauseBtn = createRef();
    this._startBtn = createRef();
    this._setTing = createRef();
    this._dropDown = createRef();
  }

  /**
   * @description 设置 设置的 couldEventHide 为false
   * @private
   */
  _onShow = () => {
    this.setState({disabledMouseEvent: false});
  };

  /**
   * @description 设置 设置的 couldEventHide 为 true
   * @private
   */
  _onHide = () => {
    this.setState({disabledMouseEvent: true})
  };

  render() {
    let {
      isShow,
      readyToStartScreenshot,
      stopRecording,
      readyToStartRecording,
      currentStage,
      cameraList,
      microphoneList,
      cameraActiveIndex,
      microphoneActiveIndex,
      changeRecordingConfig,
    } = this.props;

    let dealCameraList = [];
    cameraList.forEach(item => {
      dealCameraList.push(item.label);
    });
    let dealMicrophoneList = [];
    microphoneList.forEach(item => {
      dealMicrophoneList.push(item.label);
    });

    return (
      <div className={styles.tool} style={{display: isShow ? 'block' : 'none'}}>
        <div className={styles.tool_videotape} ref={this._videoTapeTool}>
          <div className={styles.camera_btn + ' u-tooltip-top'} style={{display: currentStage === 1 ? 'block' : 'none'}} tooltip={FJLocalStore._('take-a-photo')}
               ref={this._takePhoto} onClick={readyToStartScreenshot}>
            <InlineSVG src={FJRecodingCameraIcon} element='div'/>
          </div>
          <div className={styles.record_btn} ref={this._recordingBtn}>
            <div className={styles.btn_border + ' u-tooltip-top'}
                 style={{display: currentStage === 4 ? 'block' : 'none'}}
                 ref={this._pauseBtn}
                 onClick={stopRecording}
                 tooltip={FJLocalStore._('stop-recording')}>
              <div className={styles.btn_pause}/>
            </div>
            <div className={styles.btn_border + ' u-tooltip-top'}
                 style={{display: currentStage !== 4 ? 'block' : 'none'}}
                 ref={this._startBtn}
                 onClick={readyToStartRecording}
                 tooltip={FJLocalStore._('start-recording')}
            >
              <div className={styles.btn_start}/>
            </div>
          </div>

          <div ref={this._setTing} style={{display: currentStage === 1 ? 'block' : 'none'}}>
            <FJDropDown
              overlay={
                <FJRecordingSet onShow={this._onShow}
                                onHide={this._onHide}
                                cameraList={dealCameraList}
                                microphoneList={dealMicrophoneList}
                                cameraActiveIndex={cameraActiveIndex}
                                microphoneActiveIndex={microphoneActiveIndex}
                                changeRecordingConfig={changeRecordingConfig}
                />
              }
              placement='topRight'
              propsTop={-10}
              propsLeft={8}
              couldEventHide={this.state.disabledMouseEvent}
              ref={this._dropDown}
              zIndex={1010}
            >
              <ForwardTrigger />
            </FJDropDown>
          </div>
        </div>
      </div>
    );
  }
}

export default FJVideoTapeTool;

